import { classNames } from '../../utils';
import { FormInputCommonProps } from './types';
import CheckIcon from '../icons/components/CheckIcon';
interface CheckboxInputProps extends FormInputCommonProps {
  checked?: boolean;
  readOnly?: boolean;
  onChange?: (value: any) => void;
  label?: string;
  id?: string;
}

export const CheckboxInput: React.FC<CheckboxInputProps> = ({
  className = '',
  checked,
  disabled,
  onChange,
  id,
  label,
  readOnly,
}) => {
  return (
    <>
      <div className={classNames('relative h-[18px] w-[18px]', className)}>
        <input
          readOnly={readOnly}
          type="checkbox"
          className={classNames(
            '__checkbox-input border-sunroom-900 checked:bg-sunroom-900 checked:text-sunroom-900 focus:text-sunroom-900 focus:ring-sunroom-900 h-[18px] w-[18px] cursor-pointer appearance-none rounded-[4px] border-[2px] bg-white focus:outline-none focus:ring-0 focus:ring-offset-0 active:outline-none',
            disabled ? 'cursor-default opacity-50' : 'opacity-100'
          )}
          checked={checked}
          onChange={(e) => {
            if (onChange) {
              onChange(e);
            }
          }}
          id={id}
        />
        {checked ? (
          <CheckIcon className="absolute left-[2px] top-[4px] h-[10px] w-[13px] text-white" />
        ) : null}
      </div>
      {label ? (
        <label className="text-body ml-3 cursor-pointer" htmlFor={id}>
          {label}
        </label>
      ) : null}
    </>
  );
};
